import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { Container, Modal, Form } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const Students = () => {
  const [show, setShow] = useState(false);
  const [students, setStudents] = useState([]);
  const [update, setUpdate] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    surname: '',
    email: '',
    contact: '',
    file: null,
    username: '',
    institute: '',
    country: '',
    dob: '',
    educationLevel: '',
    department: '',
    major: ''
  });

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async () => {
    try {
      const response = await axios.get('https://backend.writerswright.com/api/v1/admin/getStudents');
      setStudents(response.data);
    } catch (error) {
      console.error('Error fetching students data:', error);
    }
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleFileChange = (e) => setFormData({ ...formData, file: e.target.files[0] });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (update) {
        const form = new FormData();
        for (const key in formData) {
          form.append(key, formData[key]);
        }

        const response = await axios.put(`https://backend.writerswright.com/api/v1/admin/updateStudent?Id=${Cookies.get('uId')}`, form, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        console.log(response.data); // Log the response for debugging

      } else {
        const form = new FormData();
        for (const key in formData) {
          form.append(key, formData[key]);
        }

        const response = await axios.post('https://backend.writerswright.com/api/v1/student/register', form, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });

        console.log(response.data); // Log the response for debugging

      }
      fetchStudents(); // Refresh the students list
      handleClose(); // Close the modal after successful submission
    } catch (error) {
      console.error('Error submitting add student form:', error);
      if (error.response) {
        console.error('Server response:', error.response.data); // Log server response for detailed error
        alert(`Failed to add student: ${error.response.data.message}`); // Display server error message to user
      } else {
        alert('Failed to add student. Please check the server logs.'); // Fallback message if no detailed response available
      }
    }
  };


  const navigate = useNavigate();

  const navigateToStudentsDetails = () => {
    navigate('/admin-portal/students-details');
  };

  const handleDelete = async (id) => {
    try {
      console.log('Deleting student with id:', id);
      await axios.delete(`https://backend.writerswright.com/api/v1/admin/deleteStudent?Id=${id}`);
      fetchStudents(); // Refresh the students list after deletion
    } catch (error) {
      console.error('Error deleting student:', error);
    }
  };

  return (
    <Container>
      <div className="d-flex justify-content-between align-items-center mb-3 alltitles">
        <h2 className='titleone'>Students</h2>
        <button className='button-37' onClick={() => {
          setUpdate(false); setFormData({
            name: '',
            surname: '',
            email: '',
            contact: '',
            file: null,
            username: '',
            institute: '',
            country: '',
            dob: '',
            educationLevel: '',
            department: '',
            major: ''
          }); handleShow()
        }}>Add Students</button>
      </div>
      <div className='tables'>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Sr</th>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Name</th>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Email</th>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Contact</th>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Upload Essays</th>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Details</th>
              <th style={{ color: "var(--primary)", fontWeight: "bold" }} className='text'>Actions</th>
            </tr>
          </thead>
          <tbody>
            {students.map((student, index) => (
              <tr key={student.Id}>
                <td>{index + 1}</td>
                <td>{student.Name}</td>
                <td>{student.Email}</td>
                <td>{student.Contact}</td>
                <td>{student.Title}</td>
                <td>
                  <button onClick={() => { Cookies.set('uId', student.UserId); console.log(student.UserId); navigateToStudentsDetails(); }} style={{ color: "black", background: "none", border: "none", textDecoration: "underline" }}>
                    View More
                  </button>
                </td>
                <td>
                  <FaEdit style={{ cursor: 'pointer', marginRight: '10px' }} onClick={() => {
                    setUpdate(true);
                    Cookies.set('uId', student.Id);
                    setFormData({
                      name: student.Name,
                      surname: student.Surname,
                      email: student.Email,
                      contact: student.Contact,
                      file: null,
                      username: student.Username,
                      institute: student.Institute,
                      country: student.Country,
                      dob: student.DateOfBirth,
                      educationLevel: student.EducationalLevel,
                      department: student.Department,
                      major: student.Major
                    }); handleShow()
                  }} />
                  <FaTrash style={{ cursor: 'pointer' }} onClick={() => handleDelete(student.UserId)} />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          {update ? (<Modal.Title>Update Student</Modal.Title>) : (<Modal.Title>Add Student</Modal.Title>)}
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formName">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter name"
                name="name"
                value={formData.name}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formSurname">
              <Form.Label>Surname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter surname"
                name="surname"
                value={formData.surname}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                name="email"
                value={formData.email}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formContact">
              <Form.Label>Contact</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter contact number"
                name="contact"
                value={formData.contact}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formProfilePicture">
              <Form.Label>Profile Picture</Form.Label>
              <Form.Control
                type="file"
                name="profilePicture"
                onChange={handleFileChange}
              />
            </Form.Group>

            <Form.Group controlId="formUsername">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter username"
                name="username"
                value={formData.username}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formInstitute">
              <Form.Label>Institute</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter institute"
                name="institute"
                value={formData.institute}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formCountry">
              <Form.Label>Country</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter country"
                name="country"
                value={formData.country}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formDOB">
              <Form.Label>Date of Birth</Form.Label>
              <Form.Control
                type="date"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formEducationLevel">
              <Form.Label>Education Level</Form.Label>
              <Form.Control
                as="select"
                name="educationLevel"
                value={formData.educationLevel}
                onChange={handleChange}
              >
                <option value="">Select Education Level</option>
                <option value="High School">High School</option>
                <option value="Undergraduate">Undergraduate</option>
                <option value="Postgraduate">Postgraduate</option>
              </Form.Control>
            </Form.Group>

            <Form.Group controlId="formDepartment">
              <Form.Label>Department</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter department"
                name="department"
                value={formData.department}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formMajor">
              <Form.Label>Major</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter major"
                name="major"
                value={formData.major}
                onChange={handleChange}
              />
            </Form.Group>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button variant="primary" type="submit">
                {update ? (<span>Update Student</span>) : (<span>Add Student</span>)}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default Students;
